module.exports = __webpack_public_path__ + "img/SKMA_rights.e1c37239.jpg";